module.exports = __webpack_public_path__ + "static/media/30OIOS6.ec1c8f09.jpg";